import Link from 'next/link'

const AwardCard = (props) => {
  const { color, title, link } = props

  let modifier = (color && color !== 'default') ? ` AwardCard--${color}` : ''
  const url = (link.type === 'entry' && link.url !== null) ? link.url.replace(process.env.PROJECT_URL, '/') : link.url

  const AwardCardContent = (
    <>
      {title &&
      <div className="AwardCard-main">
        <div className="AwardCard-content">
          {title &&
          <div className="AwardCard-title">
            <p>{ title }</p>
          </div>
          }
          {url &&
          <div className="AwardCard-label">
            <span className="AwardCard-labelText">{ link.label ? link.label : `Learn more` }</span>
            <svg className="AwardCard-labelArrow">
              <use xlinkHref="#icon-arrow-right"/>
            </svg>
          </div>
          }
        </div>
      </div>
      }
    </>
  )

  return (link.type === "entry" && link.url !== null) ? (
    <Link href={link.url.includes(`projects`) ? `projects/[slug]` : `news/[slug]`} as={url}>
      <a className={`AwardCard${modifier}`}>
        {AwardCardContent}
      </a>
    </Link>
  ) : (
    <a className={`AwardCard${modifier}`} href={url} target={`_blank`} rel={`noreferrer noopeneer`}>
      {AwardCardContent}
    </a>
  )
}

export default AwardCard
